import {
  px,
  type BorderRadius,
} from '@packages/systems/core/utils/WebflowCssSubset';
// @ts-expect-error - TS2305 - Module '"tinycolor2"' has no exported member 'Rgba'.
import {type Rgba} from 'tinycolor2';
import {
  matchExpression,
  Expressions,
  type ExpressionPath,
  Component,
} from '@packages/systems/wfdl';
import {type Expression} from '@packages/systems/wfdl-ast';
import {namesEqual, type Qualified} from '@packages/systems/wfdl-Qualified';
import {constantFalse} from '@packages/utilities/fp/utils';

export const setAllBordersWidth = (width: number) => ({
  borderTopWidth: px(width),
  borderBottomWidth: px(width),
  borderLeftWidth: px(width),
  borderRightWidth: px(width),
});

export const setAllBordersColor = (color: Rgba) => ({
  borderTopColor: color,
  borderBottomColor: color,
  borderLeftColor: color,
  borderRightColor: color,
});

export const setAllBordersStyle = (
  style: 'solid' | 'dashed' | 'dotted' | 'none'
) => ({
  borderTopStyle: style,
  borderBottomStyle: style,
  borderLeftStyle: style,
  borderRightStyle: style,
});

export const setAllBordersRadius = (radius: BorderRadius) => ({
  borderBottomLeftRadius: radius,
  borderBottomRightRadius: radius,
  borderTopLeftRadius: radius,
  borderTopRightRadius: radius,
});

export const findComponentPath = (
  expr: Expression,
  component: Qualified<Component.ComponentName>
) =>
  Expressions.findPaths(
    expr,
    matchExpression({
      Element: (el) => namesEqual(el.type, component),
      _: constantFalse,
    })
  )[0];

type UpdateExprValuesProps = Array<{
  path: ExpressionPath;
  expr: Expression;
}>;

export const updateExprAtPaths = (
  updateExprValues: UpdateExprValuesProps,
  expr: Expression
) =>
  updateExprValues.reduce(
    (acc, item) => Expressions.setIn(acc, item.path, item.expr),
    expr
  );
